var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dragBox",staticClass:"pagoda-drag-box",style:({width: _vm.width})},[_vm._t("default"),_c('span',{ref:"dragBar",staticClass:"pagoda-drag-bar",on:{"mousedown":_vm.mouseDown}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }